import React from 'react';

const Header = ({ category, title, children }) => (
    <div className="flex justify-between">
      <div className=" mb-10">
        <p className="text-lg font-semibold text-primary-color">{category}</p>
        <p className="text-3xl font-extrabold tracking-tight text-slate-900">
          {title}
        </p>
      </div>
        { children }
    </div>
);

export default Header;
